import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';

// eslint-disable-next-line unicorn/prefer-top-level-await, unicorn/prefer-await, no-console
bootstrapApplication(AppComponent, appConfig).catch((error) => console.error(error));
